module.exports = __webpack_public_path__ + "static/img/1_2.624c045a.jpg";